export const PRICE_DISPLAY_MODES = {
  STANDARD: 'standard',
  RETAIL_WITH_PDV: 'retailWithPdv',
  WHOLESALE_WITHOUT_PDV: 'wholesaleWithoutPdv',
};
